// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import AutoSelect from 'shared/components/Select';

import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

// Specifically exclude onBlur, since it doesn't work well with react-select
const RawSelectInput = ({ onBlur, simpleValue, ...props }) => (
  <AutoSelect
    clearable={false}
    simpleValue={simpleValue === undefined ? true : simpleValue}
    id={props.name}
    {...props}
    className={cx('input-xlarge', props.className)}
    value={props.value || ''}
  />
);

RawSelectInput.displayName = 'RawSelect';

RawSelectInput.propTypes = {
  options: PropTypes.array.isRequired,
};

const RawSelectField = wrapFormComponentWithLabelAndError(RawSelectInput);
RawSelectField.displayName = 'RawSelectField';

const SelectField = connectFormComponentToReduxForm(RawSelectField);
SelectField.displayName = 'SelectField';
export default SelectField;

const SelectInput = connectFormComponentToReduxForm(wrapFormComponentWithError(RawSelectInput));

export { SelectInput };
